import { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Box,
  Divider,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
} from '@chakra-ui/react';

import { getTableColumns } from './getTableColumns';
import messages from './messages';

export const VariantsTable = ({ product }) => {
  const intl = useIntl();

  const { fullPrice, variants, options } = product;

  const tableColumns = useMemo(
    () => getTableColumns(intl, { fullPrice, options }),
    [fullPrice, options],
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={8}
      width={{ base: '100%', lg: '70vw' }}
    >
      <Divider my={8} color="gray.300" />
      <Text fontSize="xl">
        <FormattedMessage {...messages.info} />
      </Text>
      <TableContainer>
        <Table variant="simple" colorScheme="blackAlpha">
          <Thead>
            <Tr>
              {tableColumns.map(column => (
                <Th key={column.name} {...(column.options ?? {})}>
                  {column.name}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {variants.map(variant => (
              <Tr key={variant.id}>
                {tableColumns.map(column => (
                  <Td
                    key={`${variant.id}|${column.name}`}
                    {...(column.options ?? {})}
                    fontSize="sm"
                  >
                    {column.cell(variant)}
                  </Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};
